import { defineComponent as _defineComponent } from 'vue'
import { withModifiers as _withModifiers, createElementVNode as _createElementVNode, renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f742b6ba"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "app-radio" }
const _hoisted_2 = ["name", "value", "checked"]
const _hoisted_3 = {
  key: 0,
  class: "app-radio__label"
}

import { PropType } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'AppRadio',
  props: {
  label: {
    type: String,
  },
  name: {
    type: String,
  },
  value: {
    type: Object as PropType<any>,
  },
  modelValue: {
    type: Boolean,
  },
},
  emits: [
  'update:modelValue',
],
  setup(__props) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("label", _hoisted_1, [
    _createElementVNode("input", {
      type: "radio",
      class: "app-radio__input",
      name: __props.name,
      value: __props.value,
      checked: __props.modelValue,
      onChange: _cache[0] || (_cache[0] = _withModifiers((e) => _ctx.$emit('update:modelValue', e), ["prevent"]))
    }, null, 40, _hoisted_2),
    (__props.label || _ctx.$slots['label'])
      ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
          (_ctx.$slots['label'])
            ? _renderSlot(_ctx.$slots, "label", { key: 0 })
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createTextVNode(_toDisplayString(__props.label), 1)
              ], 64))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})